<template>
  <div class="main">
    <div class="jf-content">
      <div class="main-top">
        <div class="main-search" v-show="type === 'home'">
          <el-input class="main-search-input" placeholder="请输入内容" v-model="formSearch.allKey" clearable>
            <el-button icon="el-icon-search" slot="append" @click="searchResult('AI')">
              AI分析</el-button>
          </el-input>
          <el-button class="searchResultAll" @click="searchResult('fullText')"
            :disabled="isBeijingCorpusSelected">全文检索</el-button>
          <div class="moreSet">
            <el-button @click="moreSet">更多设置</el-button>
          </div>
        </div>
        <div class="main-search" v-show="type === 'AI'">
          <el-input class="main-search-input" placeholder="请输入内容" v-model="formSearch.allKey" clearable>
            <el-button icon="el-icon-search" type="primary" :disabled="isInSearch" slot="append"
              @click="searchResult('AI')">
              AI分析</el-button>
          </el-input>
          <div class="moreSet">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
        <div class="main-search" v-show="type === 'fullText'">
          <el-input class="main-search-input" placeholder="请输入内容" v-model="formSearch.allKey" clearable>
            <el-button slot="append" @click="searchResult('fullText')"
              :disabled="isBeijingCorpusSelected">全文检索</el-button>
          </el-input>
          <div class="moreSet">
            <el-button @click="back">返回</el-button>
          </div>
        </div>
        <div class="main-time">
          时间范围：
          <el-date-picker class="datePicker" size="small" v-model="formSearch.time" type="daterange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions" value-format="yyyy-MM-dd"
            @change="selectTIme" :disabled="isBeijingCorpusSelected" />
          <div class="jf-dateType">
            <el-radio-group v-model="formSearch.radio" size="mini" @change="handleUnitClick"
              :disabled="isBeijingCorpusSelected">
              <el-radio-button v-for="item in timeZone" :key="item.id" :label="item.label">
              </el-radio-button>
            </el-radio-group>
          </div>
          <div class="dataSource">
            数据来源：
            <div class="dataSourceList">
              <el-checkbox-group v-model="formSearch.groupArticletypes" @change="handleCheckboxChange">
                <el-checkbox :label="1" :disabled="isBeijingCorpusSelected">报纸</el-checkbox>
                <el-checkbox :label="2" :disabled="isBeijingCorpusSelected">网站</el-checkbox>
                <el-checkbox :label="3" :disabled="isBeijingCorpusSelected">微信</el-checkbox>
                <!-- <el-checkbox :label="4">微博</el-checkbox> -->
                <el-checkbox :label="5" :disabled="isBeijingCorpusSelected">客户端</el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-show="type !== 'fullText'">
              <!-- 检索方式： -->
              <!-- <el-checkbox v-model="retrieval">语义检索</el-checkbox> -->
              <!-- <el-checkbox v-model="semantics">精准</el-checkbox> -->
              <!-- <el-input style="width:68px;" size="mini" v-if="semantics" v-model="coreNum" placeholder="请输入核心词数量"></el-input> -->
            </div>
          </div>
          <div class="relevance" v-show="type !== 'fullText'">
            <div style="width: 50px"></div>

            <div style="margin-left: 40px">
              <el-button icon="el-icon-setting" size="mini" circle @click="aiDialogVisible = true"></el-button>
            </div>
          </div>
          <div class="moreSet" style="color: #3e9dd3; margin-left: 60px; cursor: pointer" v-show="type === 'fullText'"
            @click="moreSet">
            更多设置
          </div>
        </div>
        <div v-show="type === 'home'" class="historical-search">
          <span class="historical-search-lable" v-if="historyList.length > 0">历史搜索</span>
          <div class="historyList">
            <div class="historyItem" v-for="(item, index) in historyList" :key="index">
              <span @click="copyQuery(item.query)">{{ item.query }}</span>
              <span class="del" @click="delHistory(item.id, index)"><i class="el-icon-circle-close"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div v-show="type === 'home'" class="main-content" v-loading="loading">
        <div class="main-left">
          <span class="card-title">全网热点</span>
          <div class="network-hot-list" v-for="(item, index) in networkList" :key="index">
            <div class="network-hot-title" @click="openDetail(item)">
              {{ item.title }}
            </div>
            <div class="network-hot-info">
              <div>
                <span class="jf-tag">
                  <em class="tag1" v-if="item.viocesize >= 1 && item.viocesize <= 9">
                    原创
                  </em>
                  <em class="tag2" v-else>转载</em>
                </span>
                <span class="time">{{ item.paperName || item.papername }} |
                  {{ item.updatetime | handleTime }}</span>
              </div>
              <div>
                <!-- <span class="quote">引用</span> -->
                <span class="original" @click="openUrl(item.url)">原文</span>
              </div>
            </div>
          </div>
        </div>
        <div class="main-right">
          <span class="card-title">宣城热点</span>
          <div class="network-hot-list" v-for="(item, index) in shHotList" :key="index">
            <div class="network-hot-title" @click="openDetail(item)">
              {{ item.title }}
            </div>
            <div class="network-hot-info">
              <div>
                <span class="jf-tag">
                  <em class="tag1" v-if="item.viocesize >= 1 && item.viocesize <= 9">
                    原创
                  </em>
                  <em class="tag2" v-else>转载</em>
                </span>
                <span class="time">{{ item.paperName || item.papername }} |
                  {{ item.updatetime | handleTime }}</span>
              </div>
              <div>
                <!-- <span class="quote">引用</span> -->
                <span class="original" @click="openUrl(item.url)">原文</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- AI分析 -->
      <ai-analysis ref="aiAnalysis" v-if="type === 'AI'" :retrieval="retrieval" :semantics="semantics"
        :coreNum="coreNum" :formSearch="formSearch" :aiSetForm="aiSetForm"
        @searchComplete="searchComplete"></ai-analysis>
      <!-- 全文检索 -->
      <ai-full-Text ref="aiFullText" v-if="type === 'fullText'" :formSearch="formSearch"></ai-full-Text>
      <!-- 更多设置 -->
      <selection-search :moreSearch="formSearch" :timeType="dataType" :dialogVisible="dialogVisible"
        @closeDialogVisible="closeDialogVisible" @handleMoreSet="handleMoreSet"></selection-search>
    </div>
    <el-dialog :visible.sync="dialogDetailVisible" title="" width="45%" @close="handleDetailDialogClose"
      :append-to-body="true" :lock-scroll="false" top="6vh">
      <article-detail :articleDetail="articleDetail"></article-detail>
    </el-dialog>

    <!-- AI分析配置dialog -->
    <el-dialog :visible.sync="aiDialogVisible" title="AI分析配置" width="25%" :append-to-body="true" :lock-scroll="false"
      top="6vh" :close-on-click-modal="false">
      <div>
        <el-form :model="aiSetForm" label-position="top" size="mini" label-width="120px">
          <el-form-item label="社区最小节点数" prop="minNodeNumber">
            <el-input v-model="aiSetForm.minNodeNumber" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="社区节点相似率" prop="minSimilarity">
            <el-input v-model="aiSetForm.minSimilarity" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="向量相似度" prop="minVectorSimilarity">
            <el-input v-model="aiSetForm.minVectorSimilarity" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="相连节点过滤" prop="filterMaxNodeLink" class="ai-switch">
            <el-switch v-model="aiSetForm.filterMaxNodeLink" active-text="开启" inactive-text="关闭"></el-switch>
          </el-form-item>
          <el-form-item size="large" style="text-align: center; margin-top: 40px; margin-bottom: 0">
            <el-button type="primary" @click="aiDialogVisible = false">确定</el-button>
            <el-button @click="closeAiDialogVisible">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EventBus from "@/pages/EventBus.js";

let moment = require("moment");
import AiAnalysis from "./AiAnalysis.vue";
import SelectionSearch from "./SelectionSearch.vue";
import AiFullText from "./AiFullText.vue";
import ArticleDetail from "@/pages/views/project/components/ArticleDetail.vue";
import {
  GetChannelArticleList,
  GetRegionHotArticle,
  GetJfrbArticle,
  GetSearchHistory,
  ClearSingleHistory,
  SetSearchHistory,
} from "@/api/index.js";
import { removeRepeat } from "@/filters/index.js";
export default {
  components: {
    AiAnalysis,
    SelectionSearch,
    AiFullText,
    ArticleDetail,
  },
  data() {
    return {
      isInSearch: false,
      coreNum: "3",
      semantics: true,
      loading: false,
      retrieval: true,
      dialogDetailVisible: false,
      articleDetail: {},
      dialogVisible: false,
      type: "home",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天的
        },
      },
      dataType: 0,
      dateTypeList: ["近一月", "近一季", "近一年"],
      formSearch: {
        allKey: "",
        anyKey: "",
        exceptKey: "",
        industryTypeId: "0",
        searchResultType: "",
        time: [
          moment().subtract(30, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ],
        searchRange: "",
        releaseSource: "",
        original: null,
        emotion: "-1",
        emotionValueP: 100,
        emotionValueN: 45,
        tagSourceIsAnd: false,
        groupArticletypes: [1, 2, 3, 5],
        articletypes: [],
        cityids: [],
        sourceids: [],
        mediaids: [],
        customSourceIds: [],
        imageCount: null,
        haveVideo: null,
        tagEmotion: [],
        tagEmotionIsAnd: false,
        tags: [],
        contentWordsCount: "",
        classify: [],
        radio: "近一月",
      },
      historyList: [],
      networkList: [],
      shHotList: [],

      aiDialogVisible: false,
      aiSetForm: {
        minNodeNumber: "3",
        minSimilarity: "0.6",
        minVectorSimilarity: "0.7",
        filterMaxNodeLink: false,
      },

      timeZone: [
        {
          name: "MONTH",
          label: "近一月",
        },
        {
          name: "QUARTER",
          label: "近一季",
        },
        {
          name: "YEAR",
          label: "近一年",
        },
      ],
    };
  },
  computed: {
    isBeijingCorpusSelected() {
      return this.formSearch.groupArticletypes.includes(373179);
    },
  },
  mounted() {
    if (this.$route.query.date || window.localStorage.getItem("searchDate")) {
      this.formSearch.radio =
        this.$route.query.date || window.localStorage.getItem("searchDate");
      this.handleUnitClick(this.formSearch.radio);
    } else {
      this.formSearch.radio = "近一月";
      this.handleUnitClick(this.formSearch.radio);
    }
    if (this.$route.query.key) {
      this.formSearch.allKey = this.$route.query.key;
      this.formSearch.groupArticletypes = [373179];
    }
    if (this.$route.query.searchKey) {
      this.formSearch.allKey = this.$route.query.searchKey;
      this.searchResult("AI");
    }
    // 正式环境
    // if (window.location.origin === "https://xcsearch.xcrmt.com") {
    //   this.getChannelArticleList(437228); // 全网热点栏目
    //   this.getRegionHotArticle(452569); // 宣城热点
    // } else {
    this.getChannelArticleList(437228); // 全网热点栏目
    this.getRegionHotArticle(452569); // 宣城热点
    // }
    this.getSearchHistory();
    // 通过EventBus，接收子组件传递的backHome
    EventBus.$on("backHome", () => {
      this.back();
    });
  },
  // provide: function () {
  //   return {
  //     vectorScore: () => this.vectorScore
  //   };
  // },
  methods: {
    saveConfiguration() { },
    closeAiDialogVisible() {
      // this.aiSetForm = {
      //   minNodeNumber: "3",
      //   minSimilarity: "0.6",
      //   minVectorSimilarity: "0.7",
      //   filterMaxNodeLink: false
      // };
      this.aiDialogVisible = false;
    },
    copyQuery(data) {
      this.formSearch.allKey = data;
    },
    // 获取历史记录
    getSearchHistory() {
      GetSearchHistory()
        .then((res) => {
          if (res.succeed) {
            this.historyList = res.data;
          }
        })
        .catch((err) => { });
    },

    // 删除历史记录
    delHistory(id, index) {
      ClearSingleHistory({ id: id })
        .then((res) => {
          if (res.succeed) {
            this.historyList.splice(index, 1);
          }
        })
        .catch((err) => { });
    },
    // 获取栏目文章列表
    getChannelArticleList(channelid, type) {
      let params = {
        channelid: channelid,
        date: {
          from: moment().subtract(1, "days").format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        },
        orderBy: "samecount desc",
        pageIndex: 1,
        pageSize: 50,
      };
      this.loading = true;
      GetChannelArticleList(params)
        .then((res) => {
          this.loading = false;
          if (res.succeed) {
            this.networkList =
              removeRepeat(res.data.rows, "same_id").slice(0, 5) || [];
            // 把特定的文章放在最前面
            const key = "title";
            const keyword = "习近平";
            this.networkList = this.networkList.sort((a, b) => {
              // 包含关键词返回 0/-1，放前面；不包含返回1，放后面
              const aHas = a[key].includes(keyword);
              const bHas = b[key].includes(keyword);
              if (aHas && !bHas) return -1;
              if (!aHas && bHas) return 1;
              return 0; // 同类型保持原有顺序
            });
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 获取宣城热点数据
    getRegionHotArticle(channelid) {
      let params = {
        channelid: channelid,
        date: {
          from: moment().format("YYYY-MM-DD"),
          to: moment().format("YYYY-MM-DD"),
        },
        orderBy: "degree desc",
        pageIndex: 1,
        pageSize: 50,
      };
      this.loading = true;
      GetRegionHotArticle(params)
        .then((res) => {
          this.loading = false;
          if (res.succeed) {
            this.shHotList =
              removeRepeat(res.data.rows, "same_id").slice(0, 5) || [];
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    openDetail(item) {
      GetJfrbArticle({ id: item.articlesequenceid })
        .then((res) => {
          if (res.succeed) {
            item.contenttxt = res.data.contenttxt;
            this.articleDetail = item;
            this.dialogDetailVisible = true;
          }
        })
        .catch((err) => { });
    },
    openUrl(url) {
      window.open(url, "_blank");
    },
    handleDetailDialogClose() {
      this.dialogDetailVisible = false;
    },
    selectTIme() {
      this.formSearch.radio = "";
    },
    searchComplete() {
      this.isInSearch = false;
    },
    /**
     * 输入关键字搜索
     */
    searchResult(type) {
      window.localStorage.removeItem("searchKey");
      window.localStorage.removeItem("searchDate");
      if (this.formSearch.allKey.trim() === "") {
        this.$message({
          message: "请输入内容",
          type: "warning",
        });
        return false;
      }
      if (this.formSearch.groupArticletypes.length === 0) {
        this.$message({
          message: "请勾选数据来源！",
          type: "warning",
        });
        return false;
      }
      this.type = type;
      if (type === "AI") {
        this.$nextTick(() => {
          // SetSearchHistory({ question: this.formSearch.allKey }).then((res) => {
          //   this.isInSearch = true;
          //   this.$refs.aiAnalysis.allKey = this.formSearch.allKey;
          //   this.$refs.aiAnalysis.activeSteps = 1;
          //   this.$refs.aiAnalysis.eventList = []; // 事件脉络
          //   this.$refs.aiAnalysis.article = ""; // 智能总结
          //   this.$refs.aiAnalysis.isSkeleton = true; // 重新检索
          //   this.$refs.aiAnalysis.aiResultData.organization = {}; // 相关组织
          //   this.$refs.aiAnalysis.aiResultData.person = {}; // 相关人物
          //   this.$refs.aiAnalysis.aiResultData.place = {}; // 匹配地域
          //   this.$refs.aiAnalysis.aiResultData.wordRelation = {}; // 信息图谱
          //   // this.$refs.aiAnalysis.getSearchList(this.formSearch);
          //   this.$refs.aiAnalysis.loadHotLlist(); // 刷新热点报道
          //   this.$refs.aiAnalysis.fnNewGetEvents();
          // });

          this.isInSearch = true;
          this.$refs.aiAnalysis.allKey = this.formSearch.allKey;
          this.$refs.aiAnalysis.activeSteps = 1;
          this.$refs.aiAnalysis.eventList = []; // 事件脉络
          this.$refs.aiAnalysis.article = ""; // 智能总结
          this.$refs.aiAnalysis.isSkeleton = true; // 重新检索
          // this.$refs.aiAnalysis.aiResultData.organization = {}; // 相关组织
          // this.$refs.aiAnalysis.aiResultData.person = {}; // 相关人物
          // this.$refs.aiAnalysis.aiResultData.place = {}; // 匹配地域
          this.$refs.aiAnalysis.aiResultData.wordRelation = {}; // 信息图谱
          // this.$refs.aiAnalysis.loadHotLlist(); // 刷新热点报道
          this.$refs.aiAnalysis.fnNewGetEvents();
        });
      } else if (type === "fullText") {
        this.$nextTick(() => {
          this.$refs.aiFullText.articleListData = [];
          this.$refs.aiFullText.pageIndexVal = 1;
          this.$refs.aiFullText.articleInfo = {};
          this.$refs.aiFullText.load(this.formSearch);
        });
      }
    },

    /**
     * @description: 切换日期范围的方法
     * @param type
     * @param index
     */
    changeDate(type, index) {
      this.dataType = index;
      let time = [];
      if (type === "近一月") {
        time = [
          moment().subtract(30, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      } else if (type === "近一季") {
        time = [
          moment().subtract(90, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      } else if (type === "近一年") {
        time = [
          moment().subtract(365, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
      this.formSearch.time = time;
    },

    /**
     *切换日期范围
     */
    handleUnitClick(item) {
      switch (item) {
        case "近一周":
          this.formSearch.time = [
            new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
            new Date(),
          ];
          break;
        case "近一月":
          this.formSearch.time = [
            new Date(new Date().getTime() - 3600 * 1000 * 24 * 30),
            new Date(),
          ];
          break;
        case "近一季":
          this.formSearch.time = [
            new Date(new Date().getTime() - 3600 * 1000 * 24 * 90),
            new Date(),
          ];
          break;
        case "近一年":
          this.formSearch.time = [
            new Date(new Date().getTime() - 3600 * 1000 * 24 * 365),
            new Date(),
          ];
          break;
      }
    },
    back() {
      window.scrollTo(0, 0);

      // this.semantics = false
      this.getSearchHistory();
      this.type = "home";
      this.isInSearch = false;
    },
    moreSet() {
      this.dialogVisible = true;
    },
    closeDialogVisible() {
      this.dialogVisible = false;
    },
    handleMoreSet(data) {
      // console.log(data, "data");
      this.formSearch = { ...this.formSearch, ...data };
      this.dataType = this.formSearch.dataType;
      this.dialogVisible = false;
    },

    handleCheckboxChange(value) {
      if (value.includes(373179)) {
        this.formSearch.groupArticletypes = [373179];
        this.formSearch.time = [];
      } else {
        this.formSearch.radio = "近一月";
        this.formSearch.time = [
          moment().subtract(30, "days").format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD"),
        ];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.jf-content {
  width: 1240px;
  margin: 0 auto;

  .main-top {
    padding: 30px 30px 20px 30px;
    margin-bottom: 20px;
    margin-top: 20px;
    border-radius: 6px;
    background: #ffffff;

    .main-search {
      display: flex;
      align-items: center;

      .searchResultAll {
        margin: 0 0px 0 20px;
        color: var(--brand) !important;
        border: 1px solid var(--brand) !important;
      }

      .moreSet {
        font-size: 14px;
        color: var(--brand);
        cursor: pointer;
        margin-left: 10px;
      }
    }

    .main-search-input {
      ::v-deep .el-input-group__append {
        background-color: var(--brand);
        color: #fff;
      }
    }

    .main-time {
      margin-top: 25px;
      display: flex;
      align-items: center;
      color: #666666;

      .jf-dateType {
        display: flex;
        margin-left: 10px;
      }

      .dataSource {
        display: flex;
        align-items: center;
        margin-left: 10px;

        // margin-left: 30px;
        .dataSourceList {
          margin-left: 10px;
        }
      }
    }

    .historical-search {
      font-size: 14px;
      color: #666666;
      display: flex;
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px dashed #ebeef5;

      .historical-search-lable {
        display: inline-block;
        width: 66px;
        padding-top: 6px;
      }

      .historyList {
        display: flex;
        flex: 1;
        align-items: center;
        flex-wrap: wrap;
        max-height: 80px;
        overflow: hidden;

        .historyItem {
          font-size: 14px;
          color: #222222;
          padding: 5px 20px;
          border: 1px solid #ebeef5;
          border-radius: 15px;
          margin-left: 10px;
          cursor: pointer;
          margin-bottom: 10px;
          position: relative;
          max-width: 240px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .del {
            display: none;
            position: absolute;
            top: 5px;
            right: 4px;
          }
        }

        .historyItem:hover {
          .del {
            display: block;
          }
        }
      }
    }
  }

  .main-content {
    min-height: 400px;
    display: flex;
    justify-content: space-between;

    // background: #fff;
    // padding: 25px;
    .main-left {
      width: 50%;
      margin-right: 28px;
      border-radius: 6px;
      background: #ffffff;
      // box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.1);
      border-radius: 6px;
      overflow: hidden;

      .network-hot {
        background: url("../../../assets/jfrb/network-hot.png") no-repeat 30px 24px;
        height: 50px;
        width: 100%;
      }
    }

    .main-right {
      width: 50%;
      border-radius: 6px;
      background: #ffffff;
      // box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.1);
      border-radius: 6px;
      overflow: hidden;

      .SH-hot {
        background: url("../../../assets/jfrb/sh-hot.png") no-repeat 30px 24px;
        height: 50px;
        width: 100%;
      }
    }

    .network-hot-list {
      margin: 0 30px;
      border-bottom: 1px solid #ebeef5;
      padding-bottom: 16px;

      .network-hot-title {
        font-size: 20px;
        color: #222222;
        margin-bottom: 10px;
        margin-top: 16px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .network-hot-info {
        display: flex;
        justify-content: space-between;
        color: rgba(0, 0, 0, 0.6);

        .jf-tag {
          background: rgba(62, 157, 211, 0.1);
          border-radius: 2px;
          font-size: 12px;
          color: var(--brand);
          padding: 2px 3px;
          margin-right: 6px;

          em {
            font-style: normal;
          }
        }

        .quote {
          cursor: pointer;
        }

        .original {
          cursor: pointer;
          margin-left: 20px;
          padding-left: 20px;
          background: url("../../../assets/jfrb/source.png") no-repeat 1px 3px;
        }
      }
    }

    .network-hot-list:nth-child(6) {
      border-bottom: none;
    }
  }
}

.datePicker {
  width: 280px !important;

  /deep/ {
    .el-range-separator {
      width: 20px;
    }
  }
}

::v-deep .el-checkbox__label {
  padding-left: 5px;
}

.relevance {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.card-title {
  font-size: 20px;
  background: linear-gradient(241deg,
      rgb(16, 175, 237) 0,
      rgb(20, 69, 155) 100%);
  padding-left: 8px;
  color: transparent;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 26px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  margin: 15px 0 0 22px;
}

::v-deep .ai-switch {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;

  .el-form-item__content {
    flex: 1;
    text-align: right;
  }
}
</style>
